import React from 'react';
import Slider from "react-slick";

import * as Icons from '../Icons';

let settings = {
    mobileFirst: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
          centerMode: false,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
          centerMode: false,
        }
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
          centerMode: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
          centerMode: false,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '40px',
          slidesToScroll: 1,
        }
      }
    ]
};

const Screens = () => {
    return (<section className="section-screens section-padding section-bg" id="screens">
    <div className="container">
      <div className="section-heading text-center">
        <h2 className="title">
          Screens
        </h2>
      </div>
      <div className="text service-item text-center">
           Here goes the delicious list of Top 20 Dishes of Hyderabad that are popular worldwide!             
          </div>
      <div className="screens slider">
        <Slider {...settings}>
          <div className="screens-item"><img src={Icons.menus} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.search} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.auction} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.search9} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.search20} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.search10} alt="" className="img-fluid"/></div>
          <div className="screens-item"><img src={Icons.search9} alt="" className="img-fluid"/></div>
        </Slider>
      </div>
    </div>
  </section>)
};

export default Screens;